import { render, staticRenderFns } from "./cmpdetalhestituloreceber.vue?vue&type=template&id=21aa97c0&"
import script from "./cmpdetalhestituloreceber.vue?vue&type=script&lang=js&"
export * from "./cmpdetalhestituloreceber.vue?vue&type=script&lang=js&"
import style0 from "./cmpdetalhestituloreceber.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports